(function () {
  'use strict';

  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.wudy-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () {});
  }

  function addVariants(items, btn) {
    if (!items.length) return Promise.resolve();
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (btn) {
          btn.textContent = 'Added';
        }
        fetchCartCount();
        if (window.WudyAtc) window.WudyAtc.scheduleCheckoutRedirect();
        if (btn) {
          window.setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
          }, 1600);
        }
      })
      .catch(function () {
        if (btn) {
          btn.textContent = label;
          btn.disabled = false;
        }
      });
  }

  function isKe4Mobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function initReveal(root) {
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isKe4Mobile()) {
      root.querySelectorAll('.wudy-ke-v4__reveal').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    root.setAttribute('data-ke4-reveal-ready', 'true');
    var hidden = [];
    var ease = function (el) {
      el.classList.add('is-revealed');
    };
    var check = function () {
      var vh = window.innerHeight || 800;
      var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 6;
      for (var i = hidden.length - 1; i >= 0; i--) {
        var el = hidden[i];
        if (atBottom || el.getBoundingClientRect().top < vh * 0.9) {
          ease(el);
          hidden.splice(i, 1);
        }
      }
      if (!hidden.length) window.removeEventListener('scroll', check);
    };
    requestAnimationFrame(function () {
      var vh = window.innerHeight || 800;
      root.querySelectorAll('.wudy-ke-v4__reveal').forEach(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.88) {
          ease(el);
          return;
        }
        hidden.push(el);
      });
      window.addEventListener('scroll', check, { passive: true });
      check();
      window.setTimeout(function () {
        hidden.slice().forEach(ease);
        hidden.length = 0;
      }, 1500);
    });
  }

  function initTabs(root) {
    var tabs = root.querySelector('[data-ke4-tabs]');
    if (!tabs) return;
    var buttons = tabs.querySelectorAll('[data-ke4-tab]');
    var groups = root.querySelectorAll('[data-ke4-catalog-group]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-ke4-tab');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        groups.forEach(function (g) {
          var gkey = g.getAttribute('data-ke4-catalog-group');
          if (key === 'all') {
            g.hidden = false;
          } else {
            g.hidden = gkey !== key;
          }
        });
      });
    });
  }

  function initBundle(root) {
    var bundle = root.hasAttribute('data-ke4-bundle') ? root : root.querySelector('[data-ke4-bundle]');
    if (!bundle) return;
    var format = bundle.getAttribute('data-money-format');
    var slots = bundle.querySelectorAll('[data-ke4-bundle-slot]');
    var totalEl = bundle.querySelector('[data-ke4-bundle-total]');
    var lines = bundle.querySelectorAll('[data-ke4-bundle-line]');
    var addBtn = bundle.querySelector('[data-ke4-bundle-add]');
    var state = {};

    function selectedForSlot(slotKey) {
      var slot = bundle.querySelector('[data-ke4-bundle-slot="' + slotKey + '"]');
      if (!slot) return null;
      var active = slot.querySelector('[data-ke4-bundle-opt].is-selected') || slot.querySelector('[data-ke4-bundle-opt]');
      return active;
    }

    function refresh() {
      var sum = 0;
      slots.forEach(function (slot, idx) {
        var key = slot.getAttribute('data-ke4-bundle-slot');
        var opt = selectedForSlot(key);
        if (!opt) return;
        var cents = parseInt(opt.getAttribute('data-variant-cents') || '0', 10);
        sum += cents;
        if (lines[idx]) {
          lines[idx].querySelector('[data-ke4-bundle-line-name]').textContent = opt.getAttribute('data-product-title') || '';
          lines[idx].querySelector('[data-ke4-bundle-line-price]').textContent = money(cents, format);
        }
      });
      if (totalEl) totalEl.textContent = money(sum, format);
    }

    bundle.querySelectorAll('[data-ke4-bundle-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var slot = opt.closest('[data-ke4-bundle-slot]');
        slot.querySelectorAll('[data-ke4-bundle-opt]').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        refresh();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        slots.forEach(function (slot) {
          var key = slot.getAttribute('data-ke4-bundle-slot');
          var opt = selectedForSlot(key);
          if (!opt) return;
          var id = opt.getAttribute('data-variant-id');
          if (id) items.push({ id: Number(id), quantity: 1 });
        });
        addVariants(items, addBtn);
      });
    }

    refresh();
  }

  function initFaq(root) {
    root.querySelectorAll('[data-ke4-faq]').forEach(function (wrap) {
      var items = wrap.querySelectorAll('[data-ke4-faq-item]');
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-ke4-faq-trigger]');
        var answer = item.querySelector('[data-ke4-faq-answer]');
        var sign = item.querySelector('[data-ke4-faq-sign]');
        if (!trigger || !answer) return;
        trigger.addEventListener('click', function () {
          var open = !answer.hidden;
          items.forEach(function (other) {
            var a = other.querySelector('[data-ke4-faq-answer]');
            var s = other.querySelector('[data-ke4-faq-sign]');
            if (a) a.hidden = true;
            if (s) s.textContent = '+';
          });
          if (!open) {
            answer.hidden = false;
            if (sign) sign.textContent = '\u2212';
          }
        });
      });
    });
  }

  function initInlineAtc(root) {
    root.querySelectorAll('[data-ke4-inline-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        addVariants([{ id: Number(id), quantity: 1 }], btn);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wudy-ke-v4').forEach(function (root) {
      initReveal(root);
      initTabs(root);
      initBundle(root);
      initFaq(root);
      initInlineAtc(root);
    });
  });
})();
